import type { FocusEvent } from 'react'
import React from 'react'

import { Checkbox, CountryFlag, Icon, Tooltip, withFormikSupport } from '@fourthwall/components'
import { QuestionMarkIcon } from '@fourthwall/icons'

import type { CurrencyItem } from '../../Checkout.types'
import * as S from './CurrenciesSelect.tsx.styled'

export type CurrenciesSelectProps = {
  currencies: CurrencyItem[]
  value?: string[]
  disabled?: boolean
  onChange?: (value: string[]) => void
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void
}

const CurrenciesSelectComponent = ({
  currencies,
  value,
  disabled = false,
  onChange,
  onBlur,
}: CurrenciesSelectProps) => {
  const handleCheckboxValueChange = (currency: CurrencyItem['currency']) => {
    if (value?.includes(currency)) {
      onChange?.(value.filter((selectedCurrency) => selectedCurrency !== currency))
    } else {
      onChange?.([...(value || []), currency])
    }
  }

  const renderCurrency = (currencyItem: CurrencyItem) => {
    const { currency, flag, tooltip } = currencyItem

    return (
      <S.CurrencyListItem key={currency}>
        <Checkbox
          value={!!value?.includes(currency)}
          disabled={disabled || currencyItem.disabled}
          label={
            <S.CurrencyFlagContainer>
              <CountryFlag countryCode={flag} withLabel={false} />
              <S.CurrencyLabel>{currency}</S.CurrencyLabel>
              {tooltip && (
                <S.TooltipContainer>
                  <Tooltip
                    reference={<Icon component={QuestionMarkIcon} height={16} />}
                    placement="top"
                    strategy="fixed"
                  >
                    {tooltip}
                  </Tooltip>
                </S.TooltipContainer>
              )}
            </S.CurrencyFlagContainer>
          }
          onValueChange={() => handleCheckboxValueChange(currency)}
          onBlur={onBlur}
        />
      </S.CurrencyListItem>
    )
  }

  return <S.CurrencyList>{currencies.map(renderCurrency)}</S.CurrencyList>
}

export const CurrenciesSelect = withFormikSupport(CurrenciesSelectComponent)
